"use client"

import { Box, Container, Typography, Divider } from "@mui/material"
// import { Facebook, Instagram, X, LinkedIn, YouTube } from "@mui/icons-material"
import { Link as RouterLink } from 'react-router-dom';


// const socialIcons = [
//   { icon: <Facebook />, href: "#", label: "Facebook" },
//   { icon: <Instagram />, href: "#", label: "Instagram" },
//   { icon: <X />, href: "#", label: "X (Twitter)" },
//   { icon: <LinkedIn />, href: "#", label: "LinkedIn" },
//   { icon: <YouTube />, href: "#", label: "YouTube" },
// ]

// const legalLinks = [
//   { text: "Privacy Policy", href: "#" },
//   { text: "Terms of Use", href: "#" },
//   { text: "Cookie Preferences", href: "#" },
// ]

const Footer = () => {

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#000",
        color: "white",
        py: 4,
        px: 2,
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            gap: 3,
            mb: 4,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              color: "white",
              fontSize: "1.5rem",
              letterSpacing: 1,
            }}
          >
            Brothers Fiber
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 1, md: 4 },
              alignItems: "center",
            }}
          >
           <RouterLink to="/contact-us" style={{ textDecoration: "none" }}>
              <Typography
                sx={{
                  color: "white", 
                }}
              >
                Contact Us
              </Typography>
            </RouterLink>
            <RouterLink to="/about-us" style={{ textDecoration: "none" }}>
              <Typography
                sx={{
                  color: "white", 
                }}
              >
                About Us
              </Typography>
            </RouterLink>
            <RouterLink to="/services" style={{ textDecoration: "none" }}>
              <Typography
                sx={{
                  color: "white", 
                }}
              >
                Our Services
              </Typography>
            </RouterLink>
          </Box>

          {/* <Box sx={{ display: "flex", gap: 1 }}>
            {socialIcons.map((social) => (
              <IconButton
                key={social.label}
                href={social.href}
                Contact Us
              </Typography>
            </RouterLink>
          </Box>

          {/* <Box sx={{ display: "flex", gap: 1 }}>
            {socialIcons.map((social) => (
              <IconButton
                key={social.label}
                href={social.href}
                Contact Us
              </Typography>
            </RouterLink>
          </Box>

          {/* <Box sx={{ display: "flex", gap: 1 }}>
            {socialIcons.map((social) => (
              <IconButton
                key={social.label}
                href={social.href}
                sx={{
                  color: "white",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.1)",
                  },
                }}
                aria-label={social.label}
              >
                {social.icon}
              </IconButton>
            ))}
          </Box> */}
        </Box>

        <Divider sx={{ backgroundColor: "rgba(255,255,255,0.2)", mb: 3 }} />

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "rgba(255,255,255,0.8)",
              fontSize: "0.9rem",
            }}
          >
            © 2025 Brothers Fiber. All rights reserved.
          </Typography>
          {/* <Box
            sx={{
              display: "flex",
              gap: 3,
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            {legalLinks.map((link) => (
              <Link
                key={link.text}
                href={link.href}
                sx={{
                  color: "rgba(255,255,255,0.8)",
                  textDecoration: "underline",
                  fontSize: "0.9rem",
                  "&:hover": {
                    color: "white",
                  },
                }}
              >
                {link.text}
              </Link>
            ))}
          </Box> */}
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
